export default "__VITE_ASSET__QkP0UiXU__"